import React, { useState } from 'react'

export default function Contact() {

    const [status, setStatus] = useState("");
    const [charcount, setCharcount] = useState(0);
    const [textColor,setTextColor] = useState("black");
    const [formWidth,setFormWidth] = useState(()=>getWidth());

    const style = {
        paragraph: {
            fontSize: "18px"
        },
        aboutdiv: {
            margin: "0 auto",
            width: "75%",
            border: "1px solid black",
            borderRadius: "5px",
            backgroundColor: "white",
            padding: "20px"
        },
        overall: {
            backgroundColor: "#0b486b",
            height: "auto",
            minHeight: "80vh",
            padding: "50px 0"
        },
        link: {
            textDecoration: "none"
        },
        title: {
            fontSize: "32px",
            margin: "4px",
            textAlign: "center"
        },
        contactform: {
            textAlign: "left",
            width: formWidth,
            margin: "0 auto"
        },
        entry: {
            width: "40%",
            height: "4vh",
            border: "1px solid #0b486b",
            borderRadius: "2px"
        },
        message: {
            width: "90%",
            height: "20vh",
            border: "1px solid #0b486b",
            borderRadius: "2px"
        },
        button: {
            textAlign: "right",
            marginRight: "10%"
        },
        label: {
            marginBottom: "0"
        },
        messagelabel: {
            marginBottom: "0",
            display: "inline-block"
        },
        messagelabelcount: {
            marginBottom: "0",
            display: "inline-block",
            color: textColor
        },
        messagecontainer:{
            display: "flex",
            width: "90%",
            justifyContent: "space-between"
        }
    }

    function getWidth(){
        return window.innerWidth<800? "85%":"600px";
    }

    function windowSize (){
        if (window.innerWidth<800){
            setFormWidth("85%");
        } else {
            setFormWidth("65%");
        }
        console.log(window.innerWidth);
    }

    window.addEventListener('resize', windowSize)

    function submitForm(e) {
        e.preventDefault();
        const form = e.target;
        const data = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.open(form.method, form.action);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            if (xhr.status === 200) {
                form.reset();
                setStatus("SUCCESS");
            } else {
                setStatus("ERROR");
            }
        };
        xhr.send(data);
    }

    function formChange(e){
        let temp = e.target.value.length;
        setCharcount(temp);
        if (temp>=255){
            setTextColor("red");
        } else {
            setTextColor("black");
        }
    }

    return (
        <div style={style.overall}>
            <div style={style.aboutdiv}>
                <h2 style={style.title}>Contact Me</h2>
                <div style={style.contactform}>
                    <form
                        onSubmit={submitForm}
                        action="https://formspree.io/mjvonznq"
                        method="POST"
                        >
                        <p style={style.label}>Name:</p>
                        <input type="text" name="name" style={style.entry} />
                        <p style={style.label}>Email:</p>
                        <input type="email" name="email" style={style.entry} />
                        <div style={style.messagecontainer}>
                            <p style={style.messagelabel}>Message:</p>
                            {/* {charcount>255 ? <p style={style.messagelabel}>Just kidding, there's no limit</p> : <p style={style.messagelabelcount}>{charcount}/255</p>} */}
                            <p style={style.messagelabelcount}>{charcount}/255</p>
                        </div>
                        {/* <textarea name="message" rows="4" cols="30" style={style.message} maxlength="3000" onChange={formChange}/> */}
                        <textarea name="message" rows="4" cols="30" style={style.message} maxLength="255" onChange={formChange}/>
                        {status === "SUCCESS" ? <p>Thanks!</p> : <div style={style.button}><button>Submit</button></div>}
                        {status === "ERROR" && <p>Ooops! There was an error.</p>}
                    </form>
                        <h4>I know not everyone likes these forms. So if you prefer, shoot me an email at mike@mikeip.com</h4>
                </div>
            </div>
        </div>
    )
}